/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: index.ts
 * Project: mle-client-n
 * Committed last: 2022/10/31 @ 1657
 * ---
 * Description:
 */

/**
 * Configurazione di default del progetto
 */
export const defaultConfig = require("./defaults.json");

export const shapeConfig = require("./shapes/shapes.json");

export const precompiledConfig = require("./data-origin/precompiled.json");

export const precompiledTableConfig = require("./data-origin/tables.json");